import TWalkthroughComplete from './index.vue';

TWalkthroughComplete.install = app => {
  app.component(TWalkthroughComplete.name, TWalkthroughComplete);
};

export default TWalkthroughComplete;
